import { ApprovalTableConfiguration } from './approvalTable.configuration';
import { HeadingDefinition } from '../logbookTable/HeadingDefinition';

export function getHeadings(configuration: ApprovalTableConfiguration): HeadingDefinition[][] {
    const headings: HeadingDefinition[] = [];
    if (configuration.isTimestampVisible) {
        headings.push({
            label: 'Date',
            style: {
            }
        });
    }
    if (configuration.isApprovedDateVisible) {
        headings.push({
            label: 'On',
            style: {
            }
        });
    }
    if (configuration.isUserVisible) {
        headings.push({
            label: 'By',
            style: {
            }
        });
    }
    if (configuration.isCommentVisible) {
        headings.push({
            label: 'Justification',
            style: {
            }
        });
    }
    const levelHeading: HeadingDefinition = {
        label: 'Level',
        style: {
        },
        classed: {
            'level-column': true
        }
    };
    if (headings.length > 0) {
        const width = 100 / headings.length + '%';
        headings.forEach(h => h.style.width = width);
    } else {
        levelHeading.style.width = '100%';
    }
    headings.splice(0, 0, levelHeading);
    const result = [headings];
    return result;
}